import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export enum MirthMessageType {
  Hl7 = 'Hl7',
  Json = 'Json',
  X12 = 'X12',
}

export const MirthBlockConfigSchema = z.object({
  messageType: z.nativeEnum(MirthMessageType),
  message: z.string(),
  path: z.string().optional().default('/'),
});

export type MirthBlockConfig = z.infer<typeof MirthBlockConfigSchema>;

export const MirthBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Mirth),
  config: MirthBlockConfigSchema,
});

export type MirthBlock = z.infer<typeof MirthBlockSchema>;
